module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img01_1-4.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "title"
    }
  }, [_c('strong', [_c('em', [_vm._v("A Primer on")]), _c('br'), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECISION")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKING")])])])]), _c('a', {
    attrs: {
      "id": "title"
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_c('strong', [_c('em', [_vm._v("How Decisions Happen")])])]), _vm._v(" "), _c('p', {
    staticClass: "bauthor"
  }, [_c('strong', [_c('em', [_vm._v("James G. March")])]), _c('br'), _vm._v(" "), _c('em', [_vm._v("with the assistance of Chip Heath")])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('strong', [_vm._v("The Free Press")]), _c('br'), _c('strong', [_vm._v("New York  London  Toronto  Sydney")])])]), _c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "title"
    }
  }), _c('a', {
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")]), _c('br'), _vm._v(" A Division of Simon & Schuster Inc."), _c('br'), _vm._v(" 1230 Avenue of the Americas"), _c('br'), _vm._v(" New York, NY 10020"), _c('br')]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.SimonandSchuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.SimonandSchuster.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 1994 by James G. March")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved,"), _c('br'), _vm._v(" including the right of reproduction"), _c('br'), _vm._v(" in whole or in part in any form.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")]), _vm._v(" and colophon are trademarks"), _c('br'), _vm._v(" of Simon & Schuster Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("March, James G.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A primer on decision making: how decisions happen / James G."), _c('br'), _vm._v(" March; with the assistance of Chip Heath.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("  p.    cm")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 0-02-920035-0")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-13: 978-0-029-20035-3")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eISBN-13: 978-1-439-10833-8")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. Decision-making.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("I. Heath. Chip.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("HD30.23.M368  1994")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("658.4′03—dc20                              95—4414")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("                              CIP")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35235edf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/001.vue
// module id = 63
// module chunks = 0